'use strict'

import Swiper from '../../components/swiper'
import Hammer from '../../components/hammer.min'

export default class History
{
  constructor()
  {
    this.$elem = $('.WPHistory')

    if( this.$elem.length > 0 ){
      let self = this

      this.$header = this.$elem.find('.WPHistory__header')
      this.textTitleOriginal = this.$elem.find('.WPHistory__header h1').text()
      this.$timeline = this.$header.find('.WPHistory__header__timeline')
      this.$slideTimeline = {}
      this.$main = this.$elem.find('.WPHistory__content')
      this.$controls = this.$elem.find('.WPHistory__controls')
      this.$tabs = this.$elem.find('.WPHistory__tabs')
      this.$loader = this.$elem.find('.WPHistory__loader')
      this.isMoving = false

      $(document).ready(function(){
        self._sizesContainer()
        self._createSlideTimeLine()
        self._initModals()

        // Launch Animations
        setTimeout(function(){
          self._controllerAnimations('show')
          let $title = $('.WPHistory__header .WPHistory__header__title')
          $title.addClass('-show', 600, 'swing')
          let $subtitle = $('.WPHistory__header .WPHistory__header__subtitle')
          $subtitle.addClass('-show', 800, 'swing')
        }, 800)

        // Action in elements timeline
        self.$timeline.find('.item').on('click', function( event ){
          if( $(this).hasClass('active') || self.isMoving ){ return false }
          
          self._controller( $(this) )
          
          if(!$.isEmptyObject(self.$slideTimeline)){
            self.$slideTimeline.slideTo( $(this).index() )
            if ( window.innerWidth < 768 ) {
              let itemsToShow = 2
              let spaceBetween = 0

              if (self.$slideTimeline.params.slidesPerView != itemsToShow) {
                  self.$slideTimeline.params.slidesPerView = itemsToShow
              }
              if (self.$slideTimeline.params.spaceBetween != spaceBetween) {
                self.$slideTimeline.params.spaceBetween = spaceBetween
              }

              self.$slideTimeline.update()
            }
          }
        })

        // Navigation in tablets and mobile devices
        self.$controls.children().on('click', function( event ){
          if( self.isMoving ){ return false }
          self._moveController( self, $(this) )
        })

        // Navigation in tabs, mobile devices alone
        self.$tabs.children()
            .add( self.$main.find('.back_timeline') )
            .add( self.$header.find('.WPHistory__header__social .item') )
            .on('click', function( event ){
              if( self.isMoving ){ return false }
              self._tabsController( self, $(this) )
            })

        // Settings gestures
        if( window.innerWidth < 1024 ){
          let $elemSwipe = new Hammer(document.getElementById('wp_history'))
          $elemSwipe.on('swiperight swipeleft', function(e) {
            e.preventDefault()
            if (e.type == 'swiperight') {
              self.$controls.find('.prev').trigger('click')
            } else {
              self.$controls.find('.next').trigger('click')
            }
          })
        }

        /*self.$header.mousemove(function( event ){
          let valueWidth = self.$header.outerWidth()
          let $buttons = $('.WPHistory__header .buttons_controls')

          if( event.offsetX > ( valueWidth / 2 ) ){
            // Next
            if( !$buttons.filter('.next').hasClass('-hover') ){
              $buttons.filter('.next').addClass('-hover', 300, 'swing')
            }
            if( $buttons.filter('.prev').hasClass('-hover') ){
              $buttons.filter('.prev').removeClass('-hover', 300, 'swing')
            }
          } else{
            // Prev
            if( !$buttons.filter('.prev').hasClass('-hover') ){
              $buttons.filter('.prev').addClass('-hover', 300, 'swing')
            }
            if( $buttons.filter('.next').hasClass('-hover') ){
              $buttons.filter('.next').removeClass('-hover', 300, 'swing')
            }
          }
        })*/

        // Settings Mobile
        let newSubtitle = self.$main.find('.content .content__title').text()
        self.$header.find('.WPHistory__header__subtitle').text( newSubtitle )

        // Actions for supports other navigators
        self._crossBrowsing()
      })

      $(window).resize( ()=> {
        self._sizesContainer()

        if (!$.isEmptyObject(self.$slideTimeline)) {
            let itemsToShow = 0
            let spaceBetween = window.innerWidth >= 768 ? 30 : 0

            if ( window.innerWidth >= 768 ) {
              itemsToShow = 5
              
              if( window.innerWidth >= 1024 ){
                itemsToShow = 7
                
                if( window.innerWidth >= 1200 ){
                  itemsToShow = 8
                }
              }
            } else{
              itemsToShow = 2
            }

            if (self.$slideTimeline.params.slidesPerView != itemsToShow) {
                self.$slideTimeline.params.slidesPerView = itemsToShow
            }
            if (self.$slideTimeline.params.spaceBetween != spaceBetween) {
              self.$slideTimeline.params.spaceBetween = spaceBetween
            }

            self.$slideTimeline.update()
        }
      })

      $(window).on("orientationchange", ()=> {
        self._sizesContainer()

        if (!$.isEmptyObject(self.$slideTimeline)) {
            let itemsToShow = 0
            let spaceBetween = window.innerWidth >= 768 ? 30 : 0

            if ( window.innerWidth >= 768 ) {
              itemsToShow = 5
              
              if( window.innerWidth >= 1024 ){
                itemsToShow = 7
                
                if( window.innerWidth >= 1200 ){
                  itemsToShow = 8
                }
              }
            } else{
              itemsToShow = 2
            }

            if (self.$slideTimeline.params.slidesPerView != itemsToShow) {
                self.$slideTimeline.params.slidesPerView = itemsToShow
            }
            if (self.$slideTimeline.params.spaceBetween != spaceBetween) {
              self.$slideTimeline.params.spaceBetween = spaceBetween
            }

            self.$slideTimeline.update()
        }
      })

      $( window ).scroll( ()=> {

      })
    }
  }

  _sizesContainer()
  {
    let value = 0

    if( window.innerWidth >= 1024 ){
      if( !$('.Page.History').hasClass('grid-noGutter-middle') ){ $('.Page.History').addClass('grid-noGutter-middle') }
      if( window.innerHeight >= 1100 ){
        value = window.innerHeight - ( $('#header').outerHeight() + $('.Footer').outerHeight() )
      } else{
        if( window.innerHeight <= 950 ){
          value = window.innerHeight - ( $('#header').outerHeight() )
        } else{
          value = window.innerHeight - ( $('#header').outerHeight() + ( $('.Footer').outerHeight() / 2 ) )
        }
      }
    } else{
      if( this.$elem.hasClass('grid-noGutter-middle') ){ this.$elem.removeClass('grid-noGutter-middle') }
      value = window.innerHeight - ( $('#header').outerHeight() )
    }

    this.$elem.css({
      'min-height' : value,
      'height' : value,
      'max-height': value
    })

    if( window.innerWidth < 768 ){
      let self = this

      setTimeout(function(){
        let valueMobile = value - self.$elem.find('.WPHistory__header').outerHeight()

        self.$main.css({
            'min-height' : valueMobile,
            'height' : valueMobile,
            'max-height': valueMobile
        })

        self.$main.find('.thumbnail').css({
            'top': ( ( valueMobile - 60 ) - self.$main.find('.thumbnail').outerHeight() ) / 2
        })
      }, 100)
    } else{
      let attr = this.$main.attr('style')

      if (this.$main.attr('style') != undefined) {
        this.$main.removeAttr('style')
        this.$main.find('.thumbnail').removeAttr('style')
      }
    }
  }

  _controllerAnimations( action )
  {
    let $plugin = $('.WPHistory')
    let $pluginContent = $plugin.find('.WPHistory__content')
    let $thumbnail = $pluginContent.find('.thumbnail')
    let $title = $pluginContent.find('.content__title')
    let $content = $pluginContent.find('.content__container')
    
    if( action == 'show' ){
      $thumbnail.addClass('-show', 800, 'swing', function(){
        $title.addClass('-show', 400, 'swing')
        setTimeout(function(){
          $content.addClass('-show', 600, 'swing')
        }, 200)
      })
    } else{
      $thumbnail.addClass('-hide', 800, 'swing')
      $title.addClass('-hide', 600, 'swing')
      $content.addClass('-hide', 400, 'swing')
    }
  }

  _createSlideTimeLine()
  {
    let $mainContainer = this.$timeline
    let $items = $mainContainer.find('.item')
    let itemsToShow = 0

    if ( window.innerWidth >= 768 ) {
      itemsToShow = 5
      
      if( window.innerWidth >= 1024 ){
        itemsToShow = 7
        
        if( window.innerWidth >= 1200 ){
          itemsToShow = 8
        }
      }
    } else{
      itemsToShow = 2
    }

    if ($items.length <= itemsToShow) {
        $mainContainer.addClass('without-slide col-12 grid-noGutter-top-center')
        $items.addClass('col')
        return false
    }

    $items.addClass('swiper-slide')
    $mainContainer.addClass('with-slide')
    $mainContainer.append('<div class="swiper-wrapper"></div>')
    let $container = $mainContainer.find('.swiper-wrapper')
    $mainContainer.parent().append(`<a class="buttons_controls prev -hover"><img src="${theme_url}/images/icons/arrow_left.svg" /></a>`)
    $mainContainer.parent().append(`<a class="buttons_controls next -hover"><img src="${theme_url}/images/icons/arrow_right.svg" /></a>`)

    $.each($items, function (i, val) {
        $container.append($(this))
    })

    this.$slideTimeline = new Swiper('.WPHistory__header__timeline', {
      prevButton: '.WPHistory__header .buttons_controls.prev',
      nextButton: '.WPHistory__header .buttons_controls.next',
      slidesPerView: itemsToShow,
      spaceBetween: window.innerWidth >= 768 ? 30 : 0,
      mousewheelControl: true
    })
    
    let self = this
    setTimeout(function(){
      if (!$.isEmptyObject(self.$slideTimeline)) {
        self.$slideTimeline.update()
      }
    }, 500)
  }

  _initModals()
  {
    let self = this

    $.each(self.$main.find('.content__container__footer .item'), function( i,val ){
      if( window.innerWidth >= 768 && window.innerWidth < 1024 ){
        let posTop = '',
            posBottom = ''

        if( window.innerWidth >= 1024 ) {
          posTop = '25%'
          posBottom = '35%'
        } else{
          if( window.innerWidth >= 768 ){
            posTop = '20%'
            posBottom = '20%'
          } else{
            posTop = '10%'
            posBottom = '10%'
          }
        }
        $(this).children(':not(.modal)').leanModal({
          dismissible: true,
          opacity: .5,
          in_duration: 800,
          out_duration: 600,
          starting_top: posTop,
          ending_top: posBottom,
          ready: function (modal, trigger) {},
          complete: function () {}
        })

        $('body').append( $(this).find('.modal') )
        $('body .modal').last().find('.close_button').on('click', function( event ){
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()

          $('.lean-overlay').click()
        })
      }
    })
    self.$main.find('.content__container__footer .item img').on('click', function( event ){
      if( window.innerWidth >= 768 && window.innerWidth < 1024 ){
        if( !$(this).is('figcaption') ){
          $(this).siblings('figcaption').first().trigger('click')
        }
      } else{
        return false
      }
    })
  }

  _moveController( _this, elem )
  {
    if( elem.hasClass('prev') ){
      if( _this.$timeline.find('.active').prev().length > 0 ){
        _this.$timeline.find('.active').prev().trigger('click')

        if( elem.siblings('.next').hasClass('disabled') ){
          elem.siblings('.next').removeClass('disabled')
        }

        if( _this.$timeline.find('.active').index() == 0 ){
          elem.addClass('disabled')
        }
      } else{
        if( !elem.hasClass('disabled') ){
          elem.addClass('disabled')
        }
      }
    } else{
      if( _this.$timeline.find('.active').next().length > 0 ){
        _this.$timeline.find('.active').next().trigger('click')

        if( elem.siblings('.prev').hasClass('disabled') ){
          elem.siblings('.prev').removeClass('disabled')
        }

        if( _this.$timeline.find('.active').index() + 1 ==  _this.$timeline.find('.item').length ){
          elem.addClass('disabled')
        }
      } else{
        if( !elem.hasClass('disabled') ){
          elem.addClass('disabled')
        }
      }
    }
  }

  _tabsController( _this, elem )
  {
    _this.isMoving = true

    let $container = _this.$main.find('.container__mobile')
    let $title = _this.$header.find('.WPHistory__header__title')
    let $subtitle = _this.$header.find('.WPHistory__header__subtitle')
    let $social = _this.$header.find('.WPHistory__header__social')
    let $thumbnail = _this.$main.find('.thumbnail')
    let $tabs = _this.$elem.find('.WPHistory__tabs')

    if( elem.hasClass('back_timeline') ){
      if( !_this.$controls.children().first().is(':visible') ){ 
        _this.$controls.children().first().show('drop', { direction: 'left' }, 'slow')
        _this.$controls.children().last().show('drop', { direction: 'right' }, 'slow')
      }
      if( _this.textTitleOriginal != $title.text() ){ $title.text( _this.textTitleOriginal ) }
      
      $container.children().removeClass('-show')
      $container.addClass('-hide', 400, 'swing', function(){
        $container.removeClass('active -hide')
        $thumbnail.addClass('-show', 400, 'swing', function(){
          _this.isMoving = false
        })
      })

      $tabs.children().removeClass('-show', 200, 'swing')
    } else if( elem.parent().hasClass('buttonAction') ){
      if( !$container.find('.item.share').hasClass('-show') ){
        if( !$container.hasClass('active') ){
          $container.addClass('active')
          $thumbnail.removeClass('-show', 400, function(){
            if( _this.$controls.children().first().is(':visible') ){ 
              _this.$controls.children().first().hide('drop', { direction: 'left' }, 'slow')
              _this.$controls.children().last().hide('drop', { direction: 'right' }, 'slow')
            }
            $container
              .find('.item.share').addClass('-show', 400, 'swing')
              .siblings().removeClass('-show', 300, 'swing')
          })
        } else{
          $container
            .find('.item.share').addClass('-show', 400, 'swing')
            .siblings().removeClass('-show', 300, 'swing')
        }
        _this.isMoving = false
        $tabs.children().removeClass('-show', 200, 'swing')
      } else{
        $container.find('.back_timeline').trigger('click')
        _this.isMoving = false
        return false
      }
    } else{
      if( !elem.hasClass('-show') ){
        let funcionalityForTabs = () => {
          if( !$container.hasClass('active') ){ $container.addClass('active') }
          if( _this.$controls.children().first().is(':visible') ){ 
            _this.$controls.children().first().hide('drop', { direction: 'left' }, 'slow')
            _this.$controls.children().last().hide('drop', { direction: 'right' }, 'slow')
          }
          
          elem
            .addClass('-show', 400, 'swing')
            .siblings().removeClass('-show', 200, 'swing')

          if( !$subtitle.hasClass('-show') ){ $subtitle.addClass('show', 400, 'swing')  }
          if( _this.textTitleOriginal != $title.text() ){ $title.text( _this.textTitleOriginal ) }
          if( $social.find('a').hasClass('active') ){ $social.find('a').removeClass('active') }

          let data = elem.attr('data-content')
          switch(data) {
            case 'history':
              $container
                .children('.history').addClass('-show', 400, 'swing')
                .siblings().removeClass('-show', 300, 'swing')
              break
            case 'global':
              $container
                .children('.global').addClass('-show', 400, 'swing')
                .siblings().removeClass('-show', 300, 'swing')
              break
            case 'colombia':
              $container
                .children('.colombia').addClass('-show', 400, 'swing')
                .siblings().removeClass('-show', 300, 'swing')
              break
          }

          _this.isMoving = false
        }

        if( $container.children('.share').hasClass('-show') ){
          $container.children('.share').removeClass('-show', 300, 'swing', function(){
            funcionalityForTabs()
          })
        } else{
          $thumbnail.removeClass('-show', 400, function(){
            funcionalityForTabs()
          })
        }
      } else{
        _this.isMoving = false
        return false
      }
    }
  }

  _controller( elem )
  {
    elem.addClass('active')
    elem.siblings().removeClass('active')

    $('body > .modal').remove()

    let self = this
    self.isMoving = true

    let $plugin = $('.WPHistory')
    $plugin.find('.WPHistory__header .subtitle').removeClass('show')
    
    let $pluginContent = $plugin.find('.WPHistory__content')
    $pluginContent.css({
      'height' : $pluginContent.height()
    })

    let $tabs = $pluginContent.find('.WPHistory__tabs')
    $tabs.children().removeClass('active')

    $pluginContent.removeClass('.-content_show').addClass('.-content_hide')
    self._controllerAnimations('hide')
    setTimeout(function(){
      $pluginContent.removeClass('.-content_hide').addClass('.-content_show')
      $pluginContent.html('')
      self.$loader.addClass('active')

      let idhistory = elem.attr('idhistory')
      $.ajax({
        method: "POST",
        url: ajaxurl,
        data: { action: "search_timeline", idhistory: idhistory }
      }).done(function( response ) {
        self.$loader.removeClass('active')
        $pluginContent.html(response)

        if( window.innerWidth < 768 ){
          $pluginContent.find('.thumbnail').css({
            'top': ( ( $pluginContent.outerHeight() - 45 ) - $pluginContent.find('.thumbnail').outerHeight() ) / 2
          })
        }

        let newSubtitle = $pluginContent.find('.content h2').text()
        $plugin.find('.WPHistory__header .subtitle').text( newSubtitle )
        $plugin.find('.WPHistory__header .subtitle').addClass('show')

        if( window.innerWidth < 768 ){
          let value = window.innerHeight - ( $('#header').outerHeight() )

          setTimeout(function(){
            value = value - $plugin.find('.WPHistory__header').outerHeight()
            $pluginContent.css({
              'min-height' : value,
              'height' : value,
              'max-height': value
            })

            $pluginContent.find('.back_timeline').on('click', function( event ){
              self._tabsController( self, $(this) )
            })
          }, 100)
        }

        self._initModals()
        self._controllerAnimations('show')
        setTimeout(function(){
          $pluginContent.removeClass('.-content_show').addClass('.-content_hide')
          if( window.innerWidth >= 1024 ){
            $pluginContent.removeAttr('style')
          }
          self.isMoving = false
        }, 1400)
      })
    }, 800)
  }

  _crossBrowsing()
  {
    let self = this
    
    let adjustTimeline = () => {
      let count = 0
      let controller = setInterval(function(){
        if (!$.isEmptyObject(self.$slideTimeline)) {
          self.$slideTimeline.update()
        }
        
        count++;
        if( count == 3 ){
          clearInterval(controller)
        }
      }, 300)
    }
    
    if( $('html').hasClass('safari8') ){
      adjustTimeline()
    } else if( $('html').hasClass('iphone') && $('html').hasClass('chrome') ){
      adjustTimeline()
    }
  }
}


